import React from "react";
import LegalPage from "../components/shared/LegalPage";
import SEOHead from "../components/shared/SEOHead";
import { BreadcrumbStructuredData } from "../components/shared/StructuredData";
import { useSharedContent } from "../providers/ContentProvider";

const PrivacyPage: React.FC = () => {
  const { content, loading } = useSharedContent();
  const legal = content.legal;
  const contact = content.contact;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="text-2xl mb-2">⏳</div>
          <div>טוען...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <SEOHead
        title="מדיניות פרטיות | Touch Event"
        description="מדיניות הפרטיות של Touch Event - שירותי עיסוי רפואי לאירועים ומשרדים. מידע על איסוף ושימוש במידע אישי."
        path="/privacy"
      />
      <BreadcrumbStructuredData items={[
        { name: 'דף הבית', url: 'https://touchevent.site/' },
        { name: 'מדיניות פרטיות', url: 'https://touchevent.site/privacy' },
      ]} />
      <LegalPage title={legal?.privacyTitle || "מדיניות פרטיות"} lastUpdated={legal?.lastUpdated}>
        <div className="text-[#4b3a2c] leading-relaxed whitespace-pre-line">
          {legal?.privacyText || ""}
        </div>
        <p className="text-[#4b3a2c] mt-6">
          לשאלות: {contact.email} | {contact.phone}
        </p>
      </LegalPage>
    </>
  );
};

export default PrivacyPage;
